module.exports = __webpack_public_path__ + "img/maison-1.7ebe920b.png";